
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useLanguage } from '@/contexts/LanguageContext';
import ProfileManagement from "./ProfileManagement";
import DerivativeManagement from "./DerivativeManagement";
import DownloadHistory from "./DownloadHistory";
import FavoritesManagement from "./FavoritesManagement";
import AccountSettings from "./AccountSettings";
import { ProfileFormState, Profile } from '../types/profileTypes';

interface PanelTabsProps {
  activeTab: string;
  handleTabChange: (value: string) => void;
  profileFormState: ProfileFormState | null;
  profile: Profile | null;
  onFormStateChange: (newState: Partial<ProfileFormState>) => void;
}

const PanelTabs = ({ 
  activeTab, 
  handleTabChange, 
  profileFormState, 
  profile, 
  onFormStateChange 
}: PanelTabsProps) => {
  const { t } = useLanguage();

  return (
    <Tabs value={activeTab} onValueChange={handleTabChange}>
      <TabsList className="mb-6">
        <TabsTrigger value="profile" className="text-sm py-3 px-4">
          {t('creator.profile')}
        </TabsTrigger>
        <TabsTrigger value="downloads" className="text-sm py-3 px-4">
          {t('creator.downloads')}
        </TabsTrigger>
        <TabsTrigger value="derivatives" className="text-sm py-3 px-4">
          {t('creator.myDerivatives')}
        </TabsTrigger>
        <TabsTrigger value="favorites" className="text-sm py-3 px-4">
          {t('sidebar.myFavorites')}
        </TabsTrigger>
        <TabsTrigger value="account" className="text-sm py-3 px-4">
          Compte
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="profile">
        {profileFormState && (
          <ProfileManagement 
            userProfile={profile} 
            formState={profileFormState}
            onFormStateChange={onFormStateChange}
          />
        )}
      </TabsContent>
      
      <TabsContent value="downloads">
        <DownloadHistory />
      </TabsContent>
      
      <TabsContent value="derivatives">
        <DerivativeManagement />
      </TabsContent>
      
      <TabsContent value="favorites">
        <FavoritesManagement />
      </TabsContent>
      
      <TabsContent value="account">
        <AccountSettings />
      </TabsContent>
    </Tabs>
  );
};

export default PanelTabs;
